import Grid from "@mui/material/Grid";

import {InventoryProvider} from "../../context/InventoryContext";
import OrderingHeader from "./OrderingHeader";
import OrderingDataGrid from "./OrderingDataGrid";

export default function InventoryView() {

    return (
        <InventoryProvider>
            <Grid container spacing={4}>

                <Grid item xs={12}>
                    <OrderingHeader/>
                </Grid>

                <Grid item xs={12}>
                    <OrderingDataGrid/>
                </Grid>

            </Grid>
        </InventoryProvider>
    )
}
